export default "__VITE_ASSET__B7T$e7C9__"